import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  WcgAdvancedFilter,
  WcgAdvancedFiltersComponent
} from '@wcg/frontend-framework';

import { getAdvancedFilterFormGroup } from '../../utils';

/**
 * This component is a wrapper for the advanced filters
 * it is used to display the advanced filters and its indicators
 * */

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    WcgAdvancedFiltersComponent,
    ],
  selector: 'wcg-advanced-filter-wrapper',
  styleUrls: [],
  template: `
    @defer (when advancedFilters()) {
      <form [formGroup]="advancedFiltersFormGroup" novalidate>
        <wcg-advanced-filters
          formArrayName="filters"
          [advancedFilters]="advancedFilters()"
          (applyFilters)="
            applyFilters.emit(
              advancedFiltersFormGroup.controls.filters.getRawValue()
            )
          "
          (clearOutFilters)="clearFilters.emit()"
        />
      </form>
    }
  `,
})
export class AdvancedFilterWrapperComponent {
  advancedFilters = input<WcgAdvancedFilter>({});
  applyFilters = output<WcgAdvancedFilter[]>();
  clearFilters = output<void>();
  advancedFiltersFormGroup = getAdvancedFilterFormGroup();
}
